import { NgModule } from '@angular/core';
import { BaseModule } from '../../../shared/base.module';
import { FormsModule } from '@angular/forms';
import { MATERIALS } from '../../../app.materials';
import { TokenRoutesModule } from './tokens.routes';
import { DialogModule } from '../../../dialog/dialog.module';
import { HomeService } from '../../home.service';
import { PaginationModule } from '../../../shared/pagination/pagination.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TokensComponent } from './tokens.component';
import { TokenModalComponent } from './modals/token-modal.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
    imports: [
        MATERIALS,
        FormsModule,
        BaseModule,
        TokenRoutesModule,
        PaginationModule,
        DialogModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot()
    ],
    declarations: [
        TokensComponent,
        TokenModalComponent
    ],
    providers: [
        HomeService
    ]
})

export class TokensModule {
}
